import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "form", "input"]

  declare displayTarget: HTMLElement
  declare formTarget: HTMLFormElement
  declare inputTarget: HTMLInputElement | HTMLTextAreaElement
  declare hasInputTarget: boolean

  edit() {
    this.displayTarget.classList.add("hidden")
    this.formTarget.classList.remove("hidden")
    if (this.hasInputTarget) {
      this.inputTarget.focus()
      // Place cursor at end for text inputs
      if (this.inputTarget instanceof HTMLInputElement || this.inputTarget instanceof HTMLTextAreaElement) {
        const len = this.inputTarget.value.length
        this.inputTarget.setSelectionRange(len, len)
      }
    }
  }

  cancel() {
    this.formTarget.classList.add("hidden")
    this.displayTarget.classList.remove("hidden")
  }
}
